module.exports = __webpack_public_path__ + "img/Tat-Seng_Chua@2x.aa319f84.png";